<template>
  <div>
    <vxe-grid
      ref="table"
      border
      resizable
      auto-resize
      highlight-hover-row
      size="small"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      :row-class-name="rowClassName"
      @cell-click="cellClick"
    >
      <template v-slot:top>
        <slot name="header"></slot>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currentKey: { type: String, default: '' },
  },
  data() {
    return {
      rowCurrentKey: '',
      tableColumns: tableColumns(),
    }
  },
  watch: {
    currentKey() {
      this.rowCurrentKey = this.currentKey
    },
  },
  methods: {
    rowClassName({ row }) {
      if (this.rowCurrentKey === row.waybillCode) {
        return 'row--current'
      }
    },
    cellClick({ row }) {
      if (this.rowCurrentKey === row.waybillCode) return
      this.$emit('current-change', row)
    },
    setFirstCurrentRow() {
      const first = this.tableData[0]
      if (!first) return
      this.rowCurrentKey = first.waybillCode
      this.$emit('current-change', first)
    },
  },
}
</script>
